export default class SubscriptionForm {
    public subscriptionId: number
    public token: string
    public email: string
}